import { KintellCard, User } from '@/models'
import { get, sync } from 'vuex-pathify'
import { UsesAuthenticatedUser } from '@/mixins'
import { endsWith } from 'lodash'

export default {
  mixins: [ UsesAuthenticatedUser ],
  computed: {
    ...get({
      activeKintellCard: 'kintellCards/activeKintellCard',
    }),
    ...sync({
      activeUser: 'kintellCards/activeUser'
    })
  },
  methods: {
    attachKintellCardViewChannels () {
      this.activeKintellCard.publicChannel
        .listen('.App\\Events\\KintellCard\\UnpublishedEvent', this.handleUnpublishedEvent)
        .listen('.App\\Events\\KintellCard\\UpdatedEvent', this.handleKintellCardUpdatedEvent)
        .listen('.App\\Events\\KintellCard\\DeletedEvent', this.handleKintellCardDeletedEvent)
      if (!this.authenticatedUser || this.activeUser.id !== this.authenticatedUser.id) {
        this.activeUser.publicChannel
          .listen('.App\\Events\\User\\PublishedAdvisorUpdatedEvent', this.handleUserUpdatedEvent)
      }
    },
    handleKintellCardDeletedEvent (e) {
      if (!e.kintellCardId || e.kintellCardId !== this.activeKintellCard.id) {
        return
      }
      this.$logger.info('Kintell card deleted', e)
      this.$toast.error(this.activeUser.firstName + ' ' + this.activeUser.lastName + ' has deleted their Kintell Card "' + this.activeKintellCard.title + '" .', {
        duration: 10000
      })
      this.activeKintellCard.removeFromVuex()
      this.$router.replace('/')
    },
    handleUnpublishedEvent (e) {
      if (!e.kintellCard) {
        return
      }
      const kintellCard = new KintellCard(e.kintellCard)
      this.$logger.info('Kintell card unpublished', e)
      this.$toast.error(this.activeUser.firstName + ' ' + this.activeUser.lastName + ' has unpublished their Kintell Card "' + kintellCard.title + '" .', {
        duration: 10000
      })
      kintellCard.removeFromVuex()
      this.$router.replace('/')
    },
    handleKintellCardUpdatedEvent (e) {
      if (!e.kintellCard) {
        return
      }
      this.$logger.info('Kintell card updated', e)
      const kintellCard = new KintellCard({ ...e.kintellCard, user: this.activeUser })
      // only redirect if it's published, this it to fix awaiting review issue
      if (kintellCard.status !== 'draft' && kintellCard.status !== 'awaiting-review') {
        if (kintellCard.link !== this.$route.path && !endsWith(this.$route.path, '/book')) {
          this.$router.replace(kintellCard.link)
        } else if (kintellCard.bookLink !== this.$route.path && endsWith(this.$route.path, '/book')) {
          this.$router.replace(kintellCard.bookLink)
        }
      }
      this.$store.dispatch('kintellCards/loadKintellCardForSlug', {
        advisor: e.kintellCard.createdBy,
        kintellCard: e.kintellCard.slug,
        useCache: false,
      })
      this.$toast.info(this.activeUser.firstName + ' ' + this.activeUser.lastName + ' has updated their Kintell Card.', {
        duration: 6000
      })
    },
    handleUserUpdatedEvent (e) {
      if (!e.user) {
        return
      }
      this.$logger.info('User updated', e)
      this.activeUser = new User(e.user)
      const kintellCard = new KintellCard({ ...this.activeKintellCard, user: e.user })
      kintellCard.syncToVuex(true)
      // only redirect if it's published, this it to fix awaiting review issue
      if (kintellCard.status === 'published') {
        this.$router.replace(kintellCard.link)
      }
    },
  },
  beforeDestroy () {
    if (this.activeKintellCard) {
      this.activeKintellCard.destroy()
    }
    if (this.activeUser) {
      this.activeUser.destroy()
    }
  },
}
